export default __webpack_public_path__ + "wiIdXO4-success.svg";